// extracted by mini-css-extract-plugin
export var page = "index-module--page--1jMlS";
export var left = "index-module--left--3skpd";
export var right = "index-module--right--CNvKc";
export var infoHeader = "index-module--info-header--3vRGO";